import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Repeat = ({
  size,
  type,
  theme,
  className,
  dataTestId = "repeat-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M12.3972 0.941186C12.1367 0.681896 11.7146 0.683608 11.4544 0.945011C11.1943 1.20641 11.1946 1.62852 11.4552 1.88781L12.4999 2.92752H4.51172C2.67077 2.92752 1.17839 4.41991 1.17839 6.26085V7.16865C1.17839 7.53684 1.47686 7.83531 1.84505 7.83531C2.21324 7.83531 2.51172 7.53684 2.51172 7.16865V6.26085C2.51172 5.15629 3.40715 4.26085 4.51172 4.26085H12.5653L11.4437 5.36973C11.1815 5.62902 11.1784 6.05112 11.4368 6.31253C11.6953 6.57393 12.1174 6.57564 12.3796 6.31635L14.6192 4.10208C14.7458 3.9769 14.8173 3.80652 14.8179 3.62877C14.8185 3.45102 14.7481 3.28063 14.6223 3.15546L12.3972 0.941186Z" />
    <path d="M4.54167 15.0585C4.28152 15.3199 3.85941 15.3216 3.59885 15.0623L1.37379 12.848C1.24801 12.7228 1.17758 12.5525 1.17817 12.3747C1.17875 12.197 1.25029 12.0266 1.3769 11.9014L3.61648 9.68713C3.87873 9.42784 4.30083 9.42955 4.55927 9.69095C4.8177 9.95236 4.8146 10.3745 4.55235 10.6337L3.4308 11.7426L11.4844 11.7426C12.5889 11.7426 13.4844 10.8472 13.4844 9.74262V8.83483C13.4844 8.46664 13.7829 8.16816 14.151 8.16816C14.5192 8.16816 14.8177 8.46664 14.8177 8.83483V9.74262C14.8177 11.5836 13.3253 13.076 11.4844 13.076L3.49615 13.076L4.54093 14.1157C4.80149 14.375 4.80182 14.7971 4.54167 15.0585Z" />
  </SVGIcon>
);
